import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaCog,
  FaCashRegister,
  FaUser,
  FaUsersCog
} from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { ROLE_SUPER_ADMIN } from '../../helpers/constants';

// Import components
import ProfilePage from '../Profil/ProfilePage';
import UserManagementPage from '../Users/UserManagementPage';
import POSSettingsPage from '../Settings/POSSettingsPage';

const SettingsModule = () => {
  const { t } = useTranslation();
  const { role } = useSelector(state => state.auth);
  const isSuperAdmin = role === ROLE_SUPER_ADMIN;

  const moduleConfig = {
    id: 'settings',
    title: t('modules.settings.title'),
    description: t('modules.settings.description'),
    icon: FaCog,
    color: '#6c757d',
    menuItems: [
      { path: '/settings-module/profile', icon: FaUser, label: t('nav.profile') },
      { path: '/settings-module/pos', icon: FaCashRegister, label: 'Paramètres de caisse' },
      ...(isSuperAdmin
        ? [{ path: '/settings-module/users', icon: FaUsersCog, label: 'Utilisateurs' }]
        : []),
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/settings-module/profile" replace />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/pos" element={<POSSettingsPage />} />
        {isSuperAdmin && <Route path="/users" element={<UserManagementPage />} />}
        <Route path="*" element={<Navigate to="/unauthorized" replace />} />
      </Routes>
    </ModuleLayout>
  );
};

export default SettingsModule;
